import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { isInternational as getIsInternational } from 'lib/helpers';
import Loading from 'components/Loading';
import useAuthReady from 'utils/useAuthReady';
import { getReturnPath } from 'utils/returnPath';
import { useInternational } from '../../providers/InternationalProvider';
import { PATHS } from '../../constants';

const LOGIN_STATE_HASHES = ['#login', '#login_failed'];

const Home: React.FC = () => {
  const location = useLocation();
  const { hash } = location;
  const { loading, isLoggedIn, token } = useAuthReady();
  const international = useInternational();
  const isInternational = getIsInternational() || international;

  if (loading) {
    return <Loading />;
  }

  if ((!token && !isLoggedIn) || LOGIN_STATE_HASHES.includes(hash)) {
    // Skip prevLocation for the #login / #login_failed hashes: those mean the
    // user is already bouncing through a login-failure state, not trying to
    // reach a protected page.
    const isLoginHash = LOGIN_STATE_HASHES.includes(hash);
    return (
      <Navigate
        to={isInternational ? `${PATHS.INTERNATIONAL}/login` : '/login'}
        state={
          isLoginHash ? undefined : { prevLocation: getReturnPath(location) }
        }
      />
    );
  }
  return <Outlet />;
};

export default Home;
